import React, { useEffect, useCallback, useState} from 'react';
import {AUDIO_FX, MIDI_FX} from 'constants/effect-types.js';
import {
    setSelectedMixEffect,
    setShowTrackInstrument,
} from 'actions/index.js';
import MidiEffectComponent from 'components/effects/MidiEffectComponent.js';
import EffectComponent from 'components/effects/EffectComponent.js';
import Dropdown from 'react-dropdown';
import {midiEffectOptions, getMidiEffectOption, initializeMidiEffect, effectOptions, getEffectOption, initializeEffect} from 'components/effects/constants.js';
import EffectOption from './EffectOption.js';
import {connect} from 'react-redux';

const TrackEffects = ({
    track,
    effects,
    showEffect,
    selectedEffect,
    selectedMidiEffect,
    clearSelectedEffect,
    needsLabel,
    hasMidi,
    setShowTrackInstrument
}) => { 
    let [value, setValue] = useState(undefined);

    useEffect(() => {
        return () => {
            if (track) {
                clearSelectedEffect(AUDIO_FX);
                clearSelectedEffect(MIDI_FX);
            }
        };
    }, [track]);

    const handleChooseEffect = useCallback((e) => {
        let effect = initializeEffect(e.value, track.sequencerEngine);
        effect.enable(true);
        if (effect.wetParameter) {
            effect.wetParameter.set(1);
        }
        if (track.slotTracks) {
            track.addRackEffect(effect);
        } else {
            track.effectsChain.addEffect(effect);
        }
        setValue(e.value);
        return false;
    }, [setValue, track]);

    const handleChooseMidiEffect = useCallback((e) => {
        let effect = initializeMidiEffect(e.value, track);
        track.midiEffects.addEffect(effect);
        setValue(e.value);
    }, [setValue, track]);

    useEffect(() => {
        if (value) {
            setValue(undefined);
        }
    }, [value, setValue]);

    const moveEffectTo = useCallback((from, to) => {
        if (!track.effects[from] || !track.effects[to]) {
            return;
        }
        if (track.moveEffectTo) {
            track.moveEffectTo(from, to);
            setValue({from, to});
        }
    }, [track, setValue]);

    const moveMidiEffectTo = useCallback((from, to) => {
        if (!track.midiEffects.effects[from] || !track.midiEffects.effects[to]) {
            return;
        }
        track.moveMidiEffectTo(from, to);
        setValue({from, to});
    }, [track, setValue]);

    const onDeleteEffect = useCallback((type) => {
        clearSelectedEffect(type);
        setValue(type);
    }, []);

    
    useEffect(() => {
        if (selectedMidiEffect || selectedEffect) {
            setShowTrackInstrument(false);
        }
    }, [selectedMidiEffect, selectedEffect]);

    let effect = '';
    if (showEffect) {
        effect = selectedEffect ?
           <EffectComponent
             sequencerEngine={track.sequencerEngine}
             onDeleteEffect={() => onDeleteEffect(AUDIO_FX)}
             noSelect={true}
             track={track}
             compact={true}
             isDraggable={false}
             effect={selectedEffect}
             send={undefined}/>  : 
           selectedMidiEffect ?
           <MidiEffectComponent
             isDraggable={false}
             sequencerEngine={track.sequencerEngine}
             onDeleteEffect={() => onDeleteEffect(MIDI_FX)}
             effect={selectedMidiEffect}
             noSelect={true}
             track={track}
             compact={true}
           /> : '';
    }

    if (!track.effects) {
        return '';
    }
    return (
        <div className="track-effects">
          {needsLabel && <div className="label">
            Effects
                                    </div>}
          {effect}
          <div className="effects-container">
            <Dropdown
              className='send-effects-dropdown'
              value={value}
              options={effectOptions}
              onChange={handleChooseEffect}
              placeholder="Audio FX" />
           {track.effects.map(
                (effect, i) =>
                    <EffectOption
                      key={effect.id}
                      track={track}
                      currentSubSequence={track.subSequence}
                      effectType={"AUDIO_FX"}
                      moveEffectTo={moveEffectTo}
                      effectNumber={i}
                      effect={effect}/>)}
          </div>
          {hasMidi && needsLabel && <div className="label">
            Midi Effects
                         </div>}
        {hasMidi && <div className="midi-effects-container effects-container">
            <Dropdown
              className='send-effects-dropdown'
              value={value}
              options={midiEffectOptions}
              onChange={handleChooseMidiEffect}
              placeholder="MIDI FX" />
            {track.midiEffects && track.midiEffects.effects && track.midiEffects.effects.map(
                (effect, i) => 
                    <EffectOption
                      key={effect.id}
                      track={track}
                      currentSubSequence={track.subSequence}
                      effectType={"MIDI_FX"}
                      moveEffectTo={moveMidiEffectTo}
                      effectNumber={i}
                      effect={effect}/>)}
                    </div> }
        </div>);
}

const mapStateToProps = (state, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    
    let subId = track && track.subSequence.id;
  return {
      numEffects: track && track.effects && track.effects.length,
      numMidiEffects: track && track.midiEffects && track.midiEffects.effects.length,
      selectedEffect: track !== undefined && state.mix.selectedTrackEffects[subId] &&
          state.mix.selectedTrackEffects[subId][track.id],
      selectedMidiEffect: track !== undefined && state.mix.selectedTrackMidiEffects[subId] &&
          state.mix.selectedTrackMidiEffects[subId][track.id]
  };
};

const mapDispatchToProps = (dispatch, props) => {
    let track = props.track;
    if (track && track.tracks && track.tracks[0]) {
        track = track.tracks[0].track;
    }
    
    let subId = track && track.subSequence.id;
  return {

      setShowTrackInstrument: x => dispatch(setShowTrackInstrument(x)),
      clearSelectedEffect: (type) => 
            dispatch(
                setSelectedMixEffect(subId, track && track.id, undefined, type, undefined)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackEffects);
